import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import Toasts from 'components/library/Toasts';
import ServerError from './views/ServerError';
import verifyToken from 'services/store/features/roles/actions';
import Dashboard from 'views/Dashboard';
import { logError } from 'utils/logs';
import 'components/library/style/normalize.css';
import 'components/library/style/reset.css';
import 'components/library/style/typography.css';
import 'components/library/style/animation.css';
function App() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(verifyToken());
    });
    return (_jsx("div", { className: "App", children: _jsxs(ErrorBoundary, { FallbackComponent: ServerError, onError: logError, children: [_jsx(Dashboard, {}), _jsx(Toasts, {})] }) }));
}
export default App;
